import { SET_AUTH_TOKEN, SET_AUTH_REFRESH_TOKEN, SET_LOGOUT } from "../constants";

const initialState = {
  authToken: null,
  refreshToken: null,
  isLogout: false,
};

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_AUTH_TOKEN:
      return { ...state, authToken: payload };

    case SET_AUTH_REFRESH_TOKEN:
      return { ...state, refreshToken: payload };
    case SET_LOGOUT:
      return { ...initialState, isLogout: payload };
    default:
      return state;
  }
};
